export default Object.freeze({
  SolicitadaBanco: 1,
  RecibidaSAEE: 2,
  RecibidaSAEENoPin: 3,
  Entregada: 4,
  Cancelada: 5,
  Nuevo: 6,
  RecibidaSAEENoTarjeta: 7,
  EntregadaCSEE: 8,
  Archivada: 9,
});
